import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const fetchMeta = async () => {
  const response = await axios.get(`${API}/meta`);
  return response.data;
};

export const analyzeReport = async (payload) => {
  const response = await axios.post(`${API}/reports/analyze`, payload);
  return response.data;
};

export const emailReport = async (reportId, recipientEmail) => {
  const response = await axios.post(`${API}/reports/${reportId}/email`, {
    recipient_email: recipientEmail,
  });
  return response.data;
};

export const getPdfUrl = (reportId) => `${API}/reports/${reportId}/pdf`;
